import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResetPassword } from '../models/reset-password';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/reset_password';

  saveResetPassword(resetPassword: ResetPassword): Observable<ResetPassword> {
    return this.http.post<ResetPassword>(`${this.url}/new_request`, resetPassword)
  }

  updateResetPassword(resetPassword: ResetPassword): Observable<ResetPassword> {
    return this.http.put<ResetPassword>(`${this.url}/update_request/${resetPassword.id}`, resetPassword)
  }

  findResetPasswordById(id: number): Observable<ResetPassword> {
    return this.http.get<ResetPassword>(`${this.url}/get_email/${id}`);
  }

  findResetPasswordByToken(token: string): Observable<ResetPassword> {
    return this.http.get<ResetPassword>(`${this.url}/get_token/${token}`);
  }

}
